var _path, _path2, _rect, _rect2, _path3, _rect3, _g, _rect4, _g2, _rect5, _rect6, _rect7, _g3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 75C58.7107 75 75.5 58.2107 75.5 37.5C75.5 16.7893 58.7107 0 38 0C17.2893 0 0.5 16.7893 0.5 37.5C0.5 58.2107 17.2893 75 38 75Z",
    fill: "#98D5EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_5085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 75C58.7107 75 75.5 58.2107 75.5 37.5C75.5 16.7893 58.7107 0 38 0C17.2893 0 0.5 16.7893 0.5 37.5C0.5 58.2107 17.2893 75 38 75Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_5085)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 52.5,
    width: 74.2574,
    height: 22.5,
    fill: "#273B49"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6386,
    y: 22.5,
    width: 51.9802,
    height: 22.5,
    fill: "#FDDA21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8366 45H19.0644V52.5H16.8366V45Z",
    fill: "#071A29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2188_5085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 53,
    height: 23
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6386,
    y: 22.5,
    width: 51.9802,
    height: 22.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2188_5085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0545 45H37.6287L45.0545 22.5H52.4802L45.0545 45Z",
    fill: "#F69139"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2188_5085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 53,
    height: 23
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6386,
    y: 22.5,
    width: 51.9802,
    height: 22.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2188_5085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9059 45H52.4802L59.9059 22.5H67.3317L59.9059 45Z",
    fill: "#F69139"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.1931,
    y: 45,
    width: 2.22772,
    height: 7.5,
    fill: "#071A29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2188_5085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 53,
    height: 23
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6386,
    y: 22.5,
    width: 51.9802,
    height: 22.5,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2188_5085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2188_5085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 53,
    height: 23
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6386,
    y: 22.5,
    width: 51.9802,
    height: 22.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2188_5085)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.203 45H22.7772L30.203 22.5H37.6287L30.203 45Z",
    fill: "#F69139"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3515 45H7.92575L15.3515 22.5H22.7772L15.3515 45Z",
    fill: "#F69139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadBlock);
export default __webpack_public_path__ + "static/media/road-block.1322d7d034233b68a99505734c5cfc3e.svg";
export { ForwardRef as ReactComponent };